import { useQuery, QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useAuthedFetch } from './useAuthedFetch';

export function useAuthedQuery<Data, Error>(
  queryKey: QueryKey,
  fetchFn: (
    authenticatedFetch: (
      url: string,
      options?: RequestInit
    ) => Promise<Response>
  ) => Promise<Data>,
  options?: Omit<UseQueryOptions<Data, Error>, 'queryKey' | 'queryFn'>
) {
  const authenticatedFetch = useAuthedFetch();

  return useQuery<Data, Error>({
    queryKey,
    queryFn: () => fetchFn(authenticatedFetch),
    ...options,
  });
}
